export default __webpack_public_path__ + "static/media/tel.27c95364.svg";